import React from 'react';
import ImageSwiper from '../../../UI/ImageSwiper';
import FileUploader from './FileUploader';
import PlantFormButtons from './PlantFormButtons';
import { toast } from 'react-toastify';

const PlantFormEntries = (props) => {
  return (
    <div className="flex">
      <form
        onSubmit={props.submitForm}
        className="flex flex-col gap-4 lg:w-2/3 w-full mx-auto px-8 sm:px-0 items-end"
      >
        <div className="flex sm:flex-row flex-col w-full gap-2">
          <div className="relative flex-grow w-full">
            <label htmlFor="name" className="leading-7 text-sm text-gray-600">
              {props.isArea ? 'Area ' : 'Common Plant '} Name
            </label>
            <input
              type="text"
              id="name"
              name="name"
              value={props.formValues.name}
              onChange={props.handleInputChange}
              className="w-full bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:border-accent-500 focus:bg-transparent focus:ring-2 focus:ring-accent-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
            />
          </div>
          <div className="relative flex-grow w-full">
            <label
              htmlFor="description"
              className="leading-7 text-sm text-gray-600 text-left"
            >
              {props.isArea ? 'Area ' : 'Plant '} Description
            </label>
            <input
              type="text"
              id="description"
              name="description"
              value={props.formValues.description}
              onChange={props.handleInputChange}
              className="w-full bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:border-accent-500 focus:bg-transparent focus:ring-2 focus:ring-accent-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
            />
          </div>
        </div>

        {!props.isArea && (
          <>
            <div className="flex sm:flex-row flex-col w-full gap-2">
              <div className="relative flex-grow w-full">
                <label
                  htmlFor="scientificName"
                  className="leading-7 text-sm text-gray-600 text-left"
                >
                  Scientific Name
                </label>
                <input
                  type="text"
                  id="scientificName"
                  name="scientificName"
                  value={props.formValues.scientificName}
                  onChange={props.handleInputChange}
                  className="w-full bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:border-accent-500 focus:bg-transparent focus:ring-2 focus:ring-accent-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
                />
              </div>
              <FileUploader
                isUploading={props.isUploading}
                onFileSelectSuccess={props.handleFileSelect}
                onFileSelectError={({ error }) =>
                  toast.error(error, {
                    position: toast.POSITION.BOTTOM_LEFT,
                  })
                }
                setUploading={props.setUploading}
              />
            </div>
            {props.previews.length > 0 && (
              <div className="w-full border-4 rounded">
                <ImageSwiper
                  isLoggedin={props.isLoggedin}
                  images={props.previews}
                  removeImage={props.removeImage}
                  className="shadow-lg rounded max-w-full h-auto align-middle border-none"
                />
              </div>
            )}
          </>
        )}
        <PlantFormButtons
          isUploading={props.isUploading}
          handleOpenForm={props.handleOpenForm}
          editArea={props.editArea}
          editPlant={props.editPlant}
        />
      </form>
    </div>
  );
};

export default PlantFormEntries;
